import React, { useState, useEffect } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import '../../styles/AuditLogTab.css';

const AuditLogTab = ({ data, onChange }) => {
    const [auditLogs, setAuditLogs] = useState(data || []);

    useEffect(() => {
        setAuditLogs(data || []);
    }, [data]);

    const addNewRow = () => {
        const newRow = {
            JAuditLogID: null,
            TransDate: new Date().toISOString().split('T')[0],
            Remarks: '',
            LoginID: null,
            UserName: ''
        };
        const updated = [...auditLogs, newRow];
        setAuditLogs(updated);
        onChange(updated);
    };

    const deleteRow = (index) => {
        if (window.confirm('Delete this audit log entry?')) {
            const updated = auditLogs.filter((_, i) => i !== index);
            setAuditLogs(updated);
            onChange(updated);
        }
    };

    const updateRow = (index, field, value) => {
        const updated = [...auditLogs];
        updated[index][field] = value;
        setAuditLogs(updated);
        onChange(updated);
    };

    return (
        <div className="audit-log-tab">
            <div className="audit-toolbar">
                <button className="btn btn-primary btn-sm" onClick={addNewRow}>
                    <Plus size={16} />
                    Add Note
                </button>
            </div>

            <div className="audit-grid-wrapper">
                <table className="audit-grid">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Remarks</th>
                            <th>User</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {auditLogs.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="empty-row">
                                    No audit log entries. Click "Add Note" to add remarks.
                                </td>
                            </tr>
                        ) : (
                            auditLogs.map((row, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <input
                                            type="date"
                                            value={row.TransDate || ''}
                                            onChange={(e) => updateRow(index, 'TransDate', e.target.value)}
                                            className="grid-input"
                                            disabled={!!row.JAuditLogID}
                                        />
                                    </td>
                                    <td>
                                        <textarea
                                            value={row.Remarks || ''}
                                            onChange={(e) => updateRow(index, 'Remarks', e.target.value)}
                                            className="grid-textarea"
                                            rows="2"
                                            placeholder="Enter remarks"
                                            disabled={!!row.JAuditLogID}
                                        />
                                    </td>
                                    <td>
                                        <span className="user-name">{row.username || 'Current User'}</span>
                                    </td>
                                    <td>
                                        {!row.JAuditLogID && (
                                            <button
                                                className="btn-icon btn-danger"
                                                onClick={() => deleteRow(index)}
                                                title="Delete"
                                            >
                                                <Trash2 size={16} />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="audit-note">
                <p><strong>Note:</strong> Existing audit log entries cannot be modified or deleted.</p>
            </div>
        </div>
    );
};

export default AuditLogTab;